import React from 'react';

const About = () => {
  return (
    <section className="about-area position-relative overflow-hidden space" id="about-sec">
      <div className="container">
        <div className="row">
          <div className="col-xl-6">
            <img
              className="img-fluid rounded shadow d-block mx-auto mb-5"
              style={{ maxWidth: '100%', height: 'auto' }}
              src="/assets/images/about/1.jpeg"
              alt="About Legend Safaris"
            />
          </div>
          <div className="col sm-p-2">
            <div className="ps-xl-4 ms-xl-2">
              <h2 className="sec-title">Who are Legend Safaris Namibia?</h2>
              <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
                <div className="col-6">
                  <div className="title-area mb-20 pe-xl-5 me-xl-5 p-1">
                    <p className="sec-text mb-30">
                      At Legend Safaris Namibia, we believe that travel is not just a journey, but an experience that enriches the soul. Founded by passionate travel enthusiasts, our company specializes in curating unique, tailor-made travel experiences across the globe.
                    </p>
                  </div>
                  <div className="">
                    <h5 className="box-title">Our Mission</h5>
                    <p className="about-item_text">
                      To inspire and facilitate unforgettable adventures, connecting travelers with diverse cultures, breathtaking landscapes, and authentic local experiences.
                    </p>
                  </div>
                </div>
                <div className="col-6">
                  <div className="about-item_centent">
                    <h5 className="box-title">Why Choose Us?</h5>
                    {/* FIX: Moved ul outside of p tag */}
                    <ul className="p-1" style={{ listStyle: 'disc', paddingLeft: '20px' }}>
                      <li>
                        <b>Customized Itineraries:</b> Whether you're seeking a relaxing beach getaway, an adventurous mountain trek, or an immersive cultural experience, we design itineraries that cater to your interests and preferences.
                      </li>
                      <li>
                        <b>Expert Guides:</b> Our knowledgeable guides are locals who share their insights, ensuring you experience destinations like never before.
                      </li>
                      <li>
                        <b>Sustainable Travel:</b> We prioritize eco-friendly practices, supporting local communities and preserving the natural beauty of our destinations.
                      </li>
                      <li>
                        <b>Personalized Service:</b> We take the time to understand your travel dreams and tailor our services to meet your needs.
                      </li>
                      <li>
                        <b>Customer Satisfaction:</b> Our clients are at the heart of everything we do. We pride ourselves on delivering exceptional service and creating lasting memories.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;